// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2035":"28754d9ad8dae6f8","2584":"cfd2dc92600c014c","2882":"36236ab79e9902a3","3856":"2c0f2c28b9f9276e","9827":"af38f785de30fbaa"}[chunkId] + ".css";
};